var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal",attrs:{"id":"modal","role":"dialog","tabindex":"-1"}},[(_vm.modalMode === 'remove-connection')?_c('RemoveConnection'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }